import tw from 'tailwind-styled-components'

export const PageHeader = tw.div`
  h-56
  py-12
  px-16
  flex
  items-center
  bg-panel-background-default
  [backdrop-filter:blur(40px)]
  shadow-border-b-1
  shadow-panel-line-base
  text-panel-text-primary
  text-sm-semibold
`
